<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :show-close="false"
      :visible.sync="isOpen"
      size="50%"
      z-index="10000"
      @closed="onClosed"
    >
      <el-row slot="title" justify="space-between" type="flex">Acciones</el-row>

      <div class="p-2">
        <CardEmptyStopMessage />
      </div>

      <el-row class="p-2">
        <el-col :span="24">
          <CardSanctions
            :is-disabled="isDisabledCardSanctions"
            :is-new="true"
            :taxi="taxiById"
            @find-taxi="onFindTaxi"
            @update-sanction="onUpdateSanctionData"
          />
        </el-col>
      </el-row>

      <el-row class="p-2">
        <el-col :span="24">
          <LogoutTaxiAction />
        </el-col>
      </el-row>

      <el-row class="p-2">
        <el-col :span="24">
          <ElizaConfiguration
            :config="configPbx.eliza"
            :contracted-services="monthlyBillAndContractedServices.contratedServices"
            :customers="configGeneralSettingsWg.customers"
            :workgroup-id="workgroupId"
            @updateElizaConfiguration="onUpdateElizaConfig"
            @updateElizaCustomersConfiguration="onUpdateElizaCustomersConfig"
          >
            <div class="mb-2">
              <label class="el-form-item__label">Workgroup</label>
              <WorkgroupCentralSelector v-model="wgCentral" :show-centrals="false" />
            </div>
          </ElizaConfiguration>
        </el-col>
      </el-row>
    </el-drawer>

    <el-button class="share-button notification p-0" type="text">
      <i class="material-icons large" @click="isOpen = !isOpen">bolt</i>
      <label class="label-menu-item">Acciones</label>
    </el-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CardSanctions from "@/components/admin/taxis/tab-taxis/CardSanctions.vue";
import CardEmptyStopMessage from "@/components/admin/actions/CardEmptyStopMessage.vue";
import ElizaConfiguration from "../configs/centralita/ElizaConfiguration.vue";
import WorkgroupCentralSelector from "../common/forms/WorkgroupCentralSelector.vue";
import { getConfigByName, updateConfigByName } from "@/api/operations/config.ts";
import LogoutTaxiAction from "./actions/LogoutTaxiAction.vue";

export default {
  name: "DrawerActions",

  components: {
    CardSanctions,
    CardEmptyStopMessage,
    ElizaConfiguration,
    WorkgroupCentralSelector,
    LogoutTaxiAction,
  },

  data() {
    return {
      isOpen: false,
      isDisabledCardSanctions: true,
      taxiById: {
        sanctionData: {},
      },
      configPbx: {},
      monthlyBillAndContractedServices: {
        contratedServices: {
          cloudPbx: false,
          taximeterPriceCalculator: false,
          eliza: false,
        },
      },
      configGeneralSettingsWg: {},
      wgCentral: null,
    };
  },

  computed: {
    ...mapGetters("app", ["taxis", "selectedWorkgroupsAndCentrals"]),
    workgroupId() {
      return this.selectedWorkgroupsAndCentrals?.[0]?.wgId;
    },
  },

  async created() {
    this.wgCentral = [...this.selectedWorkgroupsAndCentrals];
    await this.loadConfigPbx();
    await this.loadGeneralSettingsWgConfig();
    await this.loadMonthlyBillAndContractedServices();
  },

  methods: {
    ...mapActions("clientTaxis", ["getTaxiById", "updateTaxi"]),

    async onFindTaxi(formGetTaxi) {
      let id = this.taxis.find((t) => t.license === formGetTaxi.license)?.id;
      if (!id) {
        this.$message({
          type: "error",
          message: "La licencia no existe",
        });
        return;
      }
      const payload = {
        params: {
          wgId: formGetTaxi.selectedWgCentral[0].wgId,
          centralId: formGetTaxi.selectedWgCentral[0].centralId
            ? formGetTaxi.selectedWgCentral[0].centralId
            : formGetTaxi.selectedWgCentral[0].wgId,
          taxiId: id,
        },
        hasToReturnData: true,
      };
      const taxi = await this.getTaxiById(payload);
      if (taxi) {
        this.taxiById = taxi;
        this.isDisabledCardSanctions = false;
      } else {
        this.$message({
          type: "error",
          message: "Problemas al encontrar el taxi, prueba otra vez",
        });
        this.taxiById = {
          sanctionData: {},
        };
        this.isDisabledCardSanctions = true;
      }
    },

    async onUpdateSanctionData(sanctionData) {
      this.taxiById.sanctionData = sanctionData;
      const payload = {
        data: this.taxiById,
        params: {
          wgId: this.taxiById.idWorkgroup,
          centralId: this.taxiById.idCentral,
          taxiId: this.taxiById.id,
        },
      };

      let isUpdated = await this.updateTaxi(payload);
      if (isUpdated) {
        this.$message({
          type: "success",
          message: `Se ha actualizado la sanción al taxi: ${this.taxiById.license}`,
        });
      } else {
        this.$message({
          type: "error",
          message: `No se ha podido actualizar la sanción al taxi: ${this.taxiById.license}`,
        });
      }
    },

    async loadGeneralSettingsWgConfig() {
      this.configGeneralSettingsWg = (await getConfigByName(
        this.workgroupId,
        "generalSettingsWg"
      )) || {
        ...this.configGeneralSettingsWg,
      };
    },

    async loadConfigPbx() {
      this.configPbx = (await getConfigByName(this.workgroupId, "pbx")) || {
        ...this.configPbx,
      };
    },

    async loadMonthlyBillAndContractedServices() {
      this.monthlyBillAndContractedServices = (await getConfigByName(
        this.workgroupId,
        "monthlyBillAndContractedServices"
      )) || { ...this.monthlyBillAndContractedServices };
    },

    onClosed() {
      this.isDisabledCardSanctions = true;
      this.taxiById = {
        sanctionData: {},
      };
    },
    async onUpdateElizaConfig(config) {
      this.configPbx.eliza = config;
      await updateConfigByName(this.workgroupId, "pbx", this.configPbx);
      await this.loadConfigPbx();
      this.$message({
        type: "success",
        message: "Se han guardado los cambios de configuración",
      });
    },
    async onUpdateElizaCustomersConfig(config) {
      this.configGeneralSettingsWg.elizaCustomers = config;
      await updateConfigByName(this.workgroupId, "generalSettingsWg", this.configGeneralSettingsWg);
      await this.loadGeneralSettingsWgConfig();
      this.$message({
        type: "success",
        message: "Se han guardado los cambios de configuración",
      });
    },
  },
};
</script>
<style scoped>
.large {
  font-size: 200%;
}

i {
  display: block;
}

.label-menu-item {
  font-size: 0.5rem;
}
</style>
